import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

 // URL: any = 'https://localhost:44306/api/Employe/';
  URL = this.ConfigService.getAPIBaseUrl() + 'api/Employe/';

  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveEmployees(data) {
    debugger;
    return this.HttpClient.post(this.URL + "InsertEmploye", data)
  }
  GetOneEmployees(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetEmploye?APPeriodId=" + APPeriodId)
  }
  GetOneEmployees_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetEmploye_LY?APPeriodId=" + APPeriodId)
  }
  
}
